import { useModelContext } from '@app/contexts/model';
import { useStorageConfirmTranslateContext } from '@app/modules/ConfirmTranslate/contexts/storage';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

type TProps = {};

export const SelectTarget: FunctionComponent<TProps> = observer(() => {
    const { translateStore } = useStorageTranslateContext();
    const { languageModel } = useModelContext();
    const { confirmTranslateStore } = useStorageConfirmTranslateContext();
    const { authorizationModel } = useModelContext();

    const user = authorizationModel.user.get();

    const categoryLangResponse = languageModel.dataCategory.get();

    let disabled = confirmTranslateStore.languageToAccept != '';

    return (
        <FormControl fullWidth>
            <InputLabel id={'target-language'}>Target language</InputLabel>
            <Select variant={'standard'} labelId='target-language' label={'Select'} disabled={disabled} value={translateStore.targetLanguageId || confirmTranslateStore.languageToAccept} onChange={(e) => (translateStore.targetLanguageId = e.target.value)}>
                {categoryLangResponse &&
                    categoryLangResponse.target.map((value) => {
                        if (confirmTranslateStore.languageToAccept != '') {
                            return (
                                <MenuItem key={value.key} value={value.key}>
                                    {value.name}
                                </MenuItem>
                            );
                        }
                        if (user.user.language_target.includes(value.key)) {
                            return (
                                <MenuItem key={value.key} value={value.key}>
                                    {value.name}
                                </MenuItem>
                            );
                        }
                    })}
            </Select>
        </FormControl>
    );
});
